import { useContext } from "react";
import { ContractContext } from "../contexts/ContractContext";

const useContract = () => useContext(ContractContext);

export default useContract;
